import { actionCreator } from 'rxbeach';
import { CrudActions } from './types';

export const crudActions = <Request, EntityType>(
  namespace: string
): CrudActions<Request, EntityType> => {
  const suffix = namespace.toUpperCase();
  return {
    /* to routines */
    apiGetItems: actionCreator<string[]>(`[${suffix}] API_GET_ITEMS`),
    apiCreate: actionCreator<Request[]>(`[${suffix}] API_CREATE`),
    apiPut: actionCreator<EntityType[]>(`[${suffix}] API_PUT`),
    apiDelete: actionCreator<string[]>(`[${suffix}] API_DELETE`),
    /* to reducers */
    setItems: actionCreator<EntityType[]>(`[${suffix}] SET_ITEMS`),
    create: actionCreator<EntityType[]>(`[${suffix}] CREATE`),
    put: actionCreator<EntityType[]>(`[${suffix}] PUT`),
    remove: actionCreator<string[]>(`[${suffix}] DELETE`),
    error: actionCreator<any>(`[${suffix}] ERROR`),
  };
};
